<template>
  <!-- <w-flex justify-center align-center v-if="$zutil.role('Pentadbir Sistem')">
    <div class="w-card__content content-hardcode">
        <w-flex class="mt3">
         <div class="xs11 text-right" >
          <w-button dark class="green--bg ml1" @click="add()">
             <w-icon class="mr1">fal fa-plus</w-icon> Tambah
         </w-button>
       </div>
      </w-flex>
    </div>
  </w-flex> -->
  <div class="w-table-wrap" >
    <table class="w-table" color="light" >
      <thead>
        <tr>
          <th class="w-table__header  text-left" width="1%">No</th>
          <th class="w-table__header  text-left">Nama</th>
          <th class="w-table__header  text-left">Status</th>
        </tr>
      </thead>

      <tbody>
        <template v-if="datas.length == 0">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
          </tr>
        </template>
        <template v-for="(dt, ind) in datas">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" >{{ind+1}}</td>
            <td class="w-table__cell text-left" >{{dt.user}}</td>
            <td class="w-table__cell text-left" >{{dt.status}}</td>
            
          </tr>
        </template>
      </tbody>
    </table>
  </div>


</template>

<script>
export default {
  name: "Pemilik",
  props:{
    data: [Array, Object],
  },
  data() {
    return {
      form : {},
      datas : [],
      
    }
  },
  methods:{
    getData(){
      this.$zcomm.get(this.api_service + 'ternakan/pemilik/'+this.data.id, {}).then(res => {
        this.datas = res
      })
    },
    
  },
      
  mounted() {
    this.getData()
    
  }
}
      

</script>  
